module.exports = __webpack_public_path__ + "static/img/pic200-26.c16b466.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pic200-26.png
// module id = lvOl
// module chunks = 30